<mbs-modal
  [showFooter]="false"
  [bodyClasses]="'py-3 px-4 m-0'"
  [isCustomModal]="true"
  [loading]="loading()">
  <ng-container modal-header>{{ 'shared:sidepanel-backup.searchResults' | i18next }}</ng-container>
  <ng-container modal-body>
    <div class="d-flex flex-column">
      <div
        #breadcrumbsBox
        class="d-flex flex-wrap align-items-center mb-2">
        @for (breadcrumb of breadcrumbs(); track breadcrumb.id) {
          @if (treeElement()?.id === breadcrumb.id) {
            <span class="d-flex align-items-center border-radius-sm bg-blue-20 p-1">
              <ng-container *ngTemplateOutlet="breadcrumbIcon; context: { $implicit: breadcrumb }"></ng-container>
              <span class="text-sm lh-1"> {{ breadcrumb.label }}</span>
            </span>
          } @else {
            <mbs-button
              class="mb-1"
              type="dark"
              [isCtrl]="true"
              [size]="mbsSize.sm"
              (click)="navigateClickHandler(breadcrumb)">
              <span class="d-flex align-items-center border-radius-sm bg-secondary p-1">
                <ng-container *ngTemplateOutlet="breadcrumbIcon; context: { $implicit: breadcrumb }"></ng-container>
                {{ breadcrumb.label }}
              </span>
            </mbs-button>
          }
          @if (!$last) {
            <span
              class="mx-2 text-gray-600 text-xxs"
              [ngClass]="breadcrumbDivider"></span>
          }
        }
      </div>

      <mbs-input
        [ngModel]="searchString()"
        (ngModelChange)="searchString.set($event)"
        [placeholder]="'shared:placeholders.searchRequest' | i18next"
        [clearButton]="true"
        (keydown.enter)="searchClickHandler()"
        (buttonClick)="searchClickHandler()"
        [appendButtons]="[{ type: 'secondary', icon: 'ico ico-Search', disabled: !searchString() }]">
      </mbs-input>

      <mbs-table-nav [showRefreshButton]="false">
        <ng-template mbsTableFilter="label">
          {{ 'shared:sidepanel-backup.searchResultsAll' | i18next: { count: searchTableData()?.length || 0 } }}

          @let selectedCount = selectedItemsForQR()?.length;

          @if (selectedCount) {
            | {{ 'shared:sidepanel-backup.searchSelected' | i18next: { count: selectedCount } }}
          }
        </ng-template>
        <ng-template mbsTableControl="append">
          <mbs-button
            type="secondary"
            [icon]="'fa fa-rotate-right'"
            (click)="downloadClickHandler()"
            [disabled]="disabledQRButton()">
            {{ 'shared:sidepanel-backup.backupStorages.restore' | i18next }}
          </mbs-button>
        </ng-template>
      </mbs-table-nav>

      <mbs-table-grid
        bindSelected="id"
        id="selected-items-for-qr-list"
        (changeSelected)="selectedItemsForQRChangeHandler($event)"
        [classesTable]="'browse-search-storage-table mb-0 -bordered -vertical'"
        [data]="searchTableData()"
        [disableScrollTopOnPageChange]="true"
        [disableViewSwitch]="true"
        [headers]="headers"
        [keepState]="true"
        [loading]="loadingRefresh()"
        [multipleSelect]="true"
        [showRefreshButton]="false"
        [selectable]="true"
        [selectedItems]="selectedItemsForQR()"
        [selectOnlyOnCheckboxClick]="true"
        [sizeTable]="mbsSize.sm"
        [showTableCheckboxes]="true"
        [stickyColumnWithVR]="true"
        [switcherView]="false"
        [maxHeight]="maxHeightTable()"
        [minBufferPx]="1500"
        [maxBufferPx]="1500"
        [minVirtualScrollItemSize]="12"
        [maxVirtualScrollItemSize]="20"
        [viewMode]="viewMode"
        [virtualScrolling]="true"
        [virtualScrollItemSizeDivider]="25">
        <ng-template
          let-item
          mbsTableCell>
          <span class="d-flex align-items-center justify-content-start position-relative cursor-pointer browse-storage-table_img">
            <img
              alt="Table main icon"
              class="browse-search-storage-table_img-main mr-2"
              [src]="item.iconCustom" />
            <mbs-text-ellipsis [tooltip]="item.label">{{ item.label }}</mbs-text-ellipsis>
          </span>
        </ng-template>
        <ng-template
          let-item
          mbsTableCell>
          <mbs-text-ellipsis [tooltip]="item.restorePath">{{ item.restorePath }}</mbs-text-ellipsis>
        </ng-template>
        <ng-template
          let-item
          mbsTableCell>
          @if (item.modifyDateUTC) {
            <mbs-backup-date-time-format
              container="body"
              defaultText="Unknown"
              [hid]="computer()?.hid"
              [placement]="'auto'"
              [showIcon]="true"
              [time]="item?.modifyDateUTC"></mbs-backup-date-time-format>
          } @else {
            —
          }
        </ng-template>
        <ng-template
          let-item
          mbsTableCell>
          @if (item.originalSize || item.originalSize === 0) {
            <mbs-text-ellipsis [tooltip]="getDiskSizeFromKB(item.originalSize)">
              {{ getDiskSizeFromKB(item.originalSize) }}
            </mbs-text-ellipsis>
          } @else {
            —
          }
        </ng-template>
      </mbs-table-grid>

      <div class="d-flex align-items-center justify-content-end mt-3">
        <mbs-button
          type="secondary"
          (click)="loadMoreClickHandler()"
          [icon]="'ico ico-Refresh'"
          [disabled]="loading() || loadingRefresh() || disableLoadMore()"
          [loading]="loadingMore()">
          <span class="nowrap">{{ 'shared:sidepanel-backup.backupStorages.browseStorage.loadMore' | i18next }}</span>
        </mbs-button>
      </div>
    </div>
  </ng-container>
</mbs-modal>

<ng-template
  #breadcrumbIcon
  let-breadcrumb>
  <span class="d-flex align-items-center justify-content-center position-relative mr-1">
    <img
      style="width: 16px; height: 16px"
      alt="Breadcrumb icon"
      [src]="breadcrumb.iconCustom" />
    @if (breadcrumb.leftTopIcon) {
      <img
        [src]="breadcrumb.leftTopIcon"
        alt="Breadcrumb icon left top"
        class="position-absolute"
        style="width: 8px; top: -1px; left: -1px" />
    }
    @if (breadcrumb.rightBottomIcon) {
      <img
        [src]="breadcrumb.rightBottomIcon"
        alt="Breadcrumb icon right bottom"
        class="position-absolute"
        style="width: 10px; bottom: -1px; right: -1px" />
    }
  </span>
</ng-template>
